export interface ScorecardCustomerPrizeOptionModel {
    /** All prize options  */
    Prizes: ScorecardCustomerPrizeOptionItemModel[];
    /** Indicates if a customer has selected  */
    CustomerHasSelected: boolean;
  }
  
  export interface ScorecardCustomerPrizeOptionItemModel {
    /** Id of the prize  */
    PrizeId: number;
    /** Title of the prize  */
    PrizeTitle: string;
    /** Type of prize   */
    PrizeType: PrizeType;
    /** Indicates if the prize has been selected  */
    Selected: boolean;
    /** If not null the date item was selected  */
    SelectionDate: Date | null;
    /** Scorecard Id  */
    ScorecardId: number;
    /** Scorecard Out of prize */
    SoldOut: boolean;
  }
  
  export enum PrizeType {
    None,
    Reward,
    GivePoints,
    GiveEcash,
    SkuItem,
    LottoEntry,
  }